import { useState } from 'react'

import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { WizardData } from 'modules/trainings/components/Shared/WizardComponent/types'

type Props = {
  amplitudeEventNext: string
}

export const EmployeeSelectorStep = ({
  data,
  onDataChanged,
  amplitudeEventNext,
}: WizardStepRenderParams<WizardData> & Props) => {
  const [selected, setSelectedEmployees] = useState<EmployeesEmployeeSelectorInput>(
    data.employeesSelection
  )

  useOnNext(() => {
    track(amplitudeEventNext, {
      from: 'my_request',
    })
  })

  return (
    <Box gap="s24">
      <Text size="400" weight="medium" color="grey1000">
        {i18n.t('trainings.training_requests.create.employee_selector_step')}
      </Text>
      <Box gap="s8">
        <EmployeeSelectorV2
          forcedFilters={{
            verb: 'TrainingsTrainingRequestRead',
          }}
          value={selected.ids ?? []}
          onChange={(value) => {
            onDataChanged({ ...data, employeesSelection: value })
            setSelectedEmployees(value)
          }}
          multiple
        />
      </Box>
    </Box>
  )
}
